
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Store, select } from '@ngrx/store';
import { Subject } from 'rxjs';
import { distinctUntilChanged, filter, switchMap, takeUntil } from 'rxjs/operators';
import { getLoadingState, getSelectedHolding } from 'src/app/modules/acbcr/common/state/reducers/holdings.reducers';
import { getCurrentRoute } from 'src/app/modules/acbcr/common/state/reducers/route.reducers';
import { ApplicationState } from 'src/app/modules/acbcr/common/state/app.state';
import { HelperDataService } from 'src/app/modules/acbcr/common/services/helper-data.service';
import { UIHelper } from 'src/app/modules/acbcr/components/common/helper/ui-helper';
import { NotaControlCppcService } from 'src/app/modules/acbcr/common/services/nota-control-cppc.service'

@Component({
  selector: 'app-nota-control-cppc',
  templateUrl: './nota-control-cppc.component.html',
  styleUrls: ['./nota-control-cppc.component.scss']
})
export class NotaControlCppcComponent implements OnInit, OnDestroy {
  destroy$: Subject<boolean> = new Subject<boolean>();
  loadingDataSpinner = false;
  isSuperAdmin = false;
  isAdmin = false;
  isOperator = false;
  isFermier = false;
  exploatatiaCurenta;
  addEditModalData;
  animaleModalData;
  itemsList = [];
  req_params = {
    page_no: 1,
    page_size: 10,
  };
  openDelete = false;
  idDelete;

  constructor(
    private store: Store<ApplicationState>,
    private helperDataService: HelperDataService,
    public notaControlCppcService: NotaControlCppcService,
  ) { }

  ngOnInit() {
    this.isSuperAdmin = UIHelper.isSuperAdmin();
    this.isAdmin = UIHelper.isAdmin();
    this.isOperator = UIHelper.isOperator();
    this.isFermier = UIHelper.isFermier();

    this.store.pipe(select(getCurrentRoute))
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: string) => {
        if (!response || !response.includes('nota-control-cppc')) {
          this.exploatatiaCurenta = null;
          this.req_params['exploatatie_id'] = null;
          this.itemsList = [];

          return;
        }

        if (response && response.includes('/exploatatie')) {
          this.store.pipe(
            select(getLoadingState),
            filter(isLoading => !isLoading),
            switchMap(() => this.store.pipe(select(getSelectedHolding))),
            distinctUntilChanged((prev, curr) => prev.id === curr.id),
            takeUntil(this.destroy$),
          ).subscribe((response: any) => {
            this.exploatatiaCurenta = response?.id;
            this.req_params['exploatatie_id'] = this.exploatatiaCurenta;
            this.changePageSize('10');
          });
        }
      });
  }

  ngOnDestroy() {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  getTableData() {
    if (!this.req_params['exploatatie_id']) {
      return;
    }

    this.loadingDataSpinner = true;
    this.itemsList = [];

    this.notaControlCppcService.listAPI(this.req_params)
      .subscribe({
        next: (response) => {
          this.loadingDataSpinner = false;
          this.itemsList = response.result;
        },
        error: (errors) => {
          this.loadingDataSpinner = false;
        }
      });
  }

  changePageSize(page_size) {
    this.req_params.page_no = 1;
    this.req_params.page_size = page_size;
    this.notaControlCppcService.page = 1;
    this.notaControlCppcService.pageSize = page_size;
    this.getTableData();
  }

  changePageNumber(event) {
    this.req_params.page_no = event;
    this.getTableData();
  }

  adaugaNotaControlCPPC() {
    this.addEditModalData = {
      exploatatie_id: this.exploatatiaCurenta,
      data_dmy: UIHelper.getCurrentDate(),
      operator_id: UIHelper.userId(),
    }
  }

  download(event, item) {
    event.target.disabled = true;
    let nr = item.numar || '';
    let data = item.data_dmy || '';
    let fisier = `Nota_control_CPPC_${nr}_${data}.pdf`;

    this.notaControlCppcService.downloadAPI({ id: item.id })
      .subscribe({
        next: (response) => {
          const blob = new Blob([response]);
          this.helperDataService.simulateDownload(blob, fisier);
          event.target.disabled = false;
        },
        error: (errors) => {
          event.target.disabled = false;
        }
      });
  }

  openEditModal(nota_id) {
    this.addEditModalData = {
      id: nota_id,
    }
  }

  openAnimaleModal(nota_id) {
    this.animaleModalData = {
      id: nota_id,
    }
  }

  openDeleteModal(id) {
    this.openDelete = true;
    this.idDelete = id;
  }

  closeDeleteModal(event) {
    this.openDelete = false;

    if (event != true) {
      return;
    }

    let buton = document.getElementsByClassName('sterge-id-' + this.idDelete)[0];
    buton?.setAttribute('disabled', 'true');
    let params = {
      id: this.idDelete,
    }

    this.notaControlCppcService.deleteAPI(params)
      .subscribe({
        next: (response) => {
          this.ngOnInit();
        }
      });
  }

  closeModal() {
    this.ngOnInit();
  }
}
